/** Shared art-direction presets for production and the comparison lab.
 * These control appearance, not resolution/LOD or biome identity. */
interface VisualStyleProfile {
  post: { grain: number; vignette: number; ca: number; soften: number; sat: number; ink: number; heritage: number; bloom: number };
  light: { strength: number; jitter: number; soft: number; rim: number; mid: number };
  environment: { haze: number; morningMist: number; warmth: number; vegetation: number; glint: number };
}
const unchanged = { haze: 1, morningMist: 0, warmth: 0, vegetation: 0, glint: 1 };
export const VISUAL_STYLES: Readonly<Record<"current" | "natural" | "coastal", VisualStyleProfile>> = {
  // Frozen pre-migration look for reproducible comparisons.
  current: {
    post: { grain: 1, vignette: .85, ca: 1, soften: .22, sat: 2, ink: 0, heritage: 0, bloom: 0 },
    light: { strength: 1, jitter: 1, soft: 1, rim: .35, mid: .45 },
    environment: unchanged,
  },
  natural: {
    post: { grain: 0, vignette: .18, ca: 0, soften: .04, sat: 1.35, ink: 0, heritage: 1, bloom: 0 },
    light: { strength: 0, jitter: 0, soft: 1, rim: .15, mid: .45 },
    environment: unchanged,
  },
  coastal: {
    post: { grain: 0, vignette: .12, ca: 0, soften: .06, sat: 1.25, ink: 0, heritage: 1, bloom: .075 },
    light: { strength: 0, jitter: 0, soft: 1, rim: .15, mid: .45 },
    environment: { haze: 1.3, morningMist: .22, warmth: .14, vegetation: 1, glint: .8 },
  },
};
export const DEFAULT_VISUAL_STYLE = "coastal";
/** Shared live presentation values; never change biome seeds or quality budgets. */
export const ENVIRONMENT = { ...VISUAL_STYLES[DEFAULT_VISUAL_STYLE].environment };
